/**
 *
 * @param disclaimerHeight
 * @param heightOverride
 * @param initialSlideHeight
 */
export const getCombinedSlideHeight = ({
    disclaimerHeight,
    heightOverride,
    initialSlideHeight
}: {
    disclaimerHeight: number;
    initialSlideHeight: number;
    heightOverride?: string;
}): number => {
    const overrideHeight = heightOverride ? parseInt(heightOverride) : 0;

    return (overrideHeight || initialSlideHeight) + disclaimerHeight;
};
